import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getVersions() {
    return axios.get(ENV.systemBase + "/settings/versions/list", this.requestConfig());
  }

  static addVersion(requestData) {
    return axios.post(ENV.systemBase + "/settings/versions/add", requestData, this.requestConfig());
  }
}

export default Service;
